import { render, staticRenderFns } from "./Issue.vue?vue&type=template&id=6b227c9e&scoped=true"
import script from "./Issue.vue?vue&type=script&lang=js"
export * from "./Issue.vue?vue&type=script&lang=js"
import style0 from "./Issue.vue?vue&type=style&index=0&id=6b227c9e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b227c9e",
  null
  
)

export default component.exports